/* @flow */

import { graphql, commitMutation } from 'react-relay';

import type { ModifyPortfolioFolderItems } from '../types';
import type { Environment } from 'react-relay';

const mutation = graphql`
    mutation ModifyPortfolioFolderItemsMutation($input: ModifyPortfolioItemsInput!) {
        modifyPortfolioItems(input: $input) {
            portfolio {
                id
            }
        }
    }
`;

function commit(
    environment: Environment,
    {
        action,
        itemsIds,
        note,
        portfolioId,
        portfolioItemsIds,
        userId,
        onCompleted,
        onError,
    }: ModifyPortfolioFolderItems
): void {
    let input = { action, portfolioId, userId };

    if (action === 'REMOVE') {
        input = { ...input, portfolioItemsIds };
    } else if (action === 'ADD') {
        input = { ...input, itemsIds, note };
    }

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
}

export default { commit };
